import React, { useState, useEffect } from "react";
import api from "../../api/axiosAuth";
import '../../style/loogosInstituciones.css';

export default function ConfigInstitucion() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [tipo, setTipo] = useState("logo");
  const [config, setConfig] = useState({});
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    cargarConfig();
  }, []);

  /* =====================================================
     🔄 CARGAR CONFIG ACTUAL
  ===================================================== */
  const cargarConfig = async () => {
    try {
      const res = await api.get("/logosInstituciones");
      setConfig(res.data || {});
    } catch (err) {
      console.log("Sin configuración aún");
    }
  };

  /* =====================================================
     📁 MANEJO ARCHIVO
  ===================================================== */
  const handleFile = (e) => {
    const archivo = e.target.files[0];
    setFile(archivo);

    if (archivo) {
      setPreview(URL.createObjectURL(archivo));
    }
  };

  /* =====================================================
     ☁️ SUBIR CLOUDINARY
  ===================================================== */
  const subir = async () => {
    if (!file) {
      setMensaje("⚠️ Selecciona un archivo");
      return;
    }

    try {
      setLoading(true);
      setMensaje("");

      const formData = new FormData();
      formData.append("archivo", file);
      formData.append("tipo", tipo);

      const res = await api.post("/logosInstituciones/upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      setMensaje("✅ Archivo actualizado correctamente");
      setFile(null);
      setPreview(null);

      // refrescar config desde backend
      await cargarConfig();

    } catch (err) {
      console.error(err);
      setMensaje("❌ Error subiendo archivo");
    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
     🔗 URL DIRECTA CLOUDINARY
  ===================================================== */
  const getUrl = (url) => {
    if (!url) return "";
    return url;
  };

  return (
    <div className="config-inst-wrap">

      <h2>🏫 Configuración de Institución</h2>
      <p className="subtitulo">
        Aquí puedes actualizar el logo institucional y la firma del rector.
      </p>

      {/* ====================== LOGO ACTUAL ====================== */}
      <div className="actuales-box">
        {config.logo_url && (
          <div className="img-card">
            <h4>Logo actual</h4>
            <img src={getUrl(config.logo_url)} alt="logo" />
          </div>
        )}

        {config.firma_rector && (
          <div className="img-card">
            <h4>Firma actual</h4>
            <img src={getUrl(config.firma_rector)} alt="firma" />
          </div>
        )}
      </div>

      <hr />

      {/* ====================== FORMULARIO ====================== */}
      <div className="form-box">

        <label>Tipo de archivo:</label>
        <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
          <option value="logo">Logo Institucional</option>
          <option value="firma">Firma Rector</option>
        </select>

        <label>Seleccionar archivo:</label>
        <input type="file" onChange={handleFile} />

        {preview && (
          <div className="preview-box">
            <p>Vista previa:</p>
            <img src={preview} alt="preview" />
          </div>
        )}

        <button onClick={subir} disabled={loading}>
          {loading ? "Subiendo..." : "☁️ Subir Archivo"}
        </button>

        {mensaje && <p className="mensaje">{mensaje}</p>}
      </div>
    </div>
  );
}
